<template>
    <div class="page-container">
        <!-- 顶部导航 -->
        <nav-bar v-if="!type" ref="navBar" :maxOpacity="0.5" bgColor="#000" @watchScroll="watchScroll">
            <div class="nav-box">
                <img class="back" :src="backUrl" @click="goBack">
                <div :style="{color:fontColor}">使用说明</div>
                <div class="back"></div>
            </div>
        </nav-bar>
        <div v-if="!type" :style="`margin-top:calc(10.333vw + ${statusBarHeight}px)`"></div>
        <div class="rule-content" v-html="rule"></div>
    </div>
</template>

<script lang="jsx">
import navBar from './components/NavBar'
import whiteBack from '../../assets/images/postalNewCustomer/back.png'
import blackBack from '../../assets/images/postalNewCustomer/back_black.png'
const rules = {
  //地铁券
  'cfa524d7-5a0d-45f8-b306-68d09aaa8087': `
    <h3>【使用时间】</h3>
    <p>青岛地铁App乘车券有效期为7天，自领取之日开始计算，过期未使用不予退还，请按时使用。</p>
    <h3>【使用规则】</h3>
    <p></p>
    <p>1.领取的青岛地铁App乘车券，可到“青岛地铁App”-“我的”-“优惠券”中查看；</p>
    <p>2. 青岛地铁App乘车券仅在用户使用青岛地铁App乘车时抵扣，使用其他工具乘车不予抵扣。</p>
  `,
  //优惠券
  'b9b4ecc6-fa81-40fb-8b3a-767a1124c71c': `
    <p></p>
    <p>丽达茂优惠券使用须知：</p>
    <p>1、此30元优惠券限用于丽达茂L4层指定餐饮店铺，单桌消费满100元可用一张，不可叠加使用，且不与其他商场及店内活动同享。</p>
    <p>2、此优惠券领取后，每张限核销一次，不可重复核销；优惠券可在以下餐饮店铺使用：</p>
    <p>箜八泰泰国料理</p>
    <p>甄花铁板烧</p>
    <p>梨花安东部队火锅</p>
    <p>烧春秋黑猪肉火锅</p>
    <p>兀岛日式烧肉丼饭</p>
    <p>兆禾日式拉面</p>
    <p>简鹿港式糖水铺</p>
    <p>迷你美珠韩式冰激凌</p>
    <p>果燃冰甜品站</p>
    <p>3、丽达茂商场地址：山东省青岛市市北区辽阳西路366号。</p>
    <p>4、此优惠券使用有效期：2022年10月26日-2022年11月30日。</p>
    <p>5、如有优惠券使用问题，请拨打丽达茂客服电话：0532-88732266。</p>
    <p>6、最终解释权归丽达茂及参与门店所有。</p>
 `,
 //数币使用场景
  'reward': `
    <p></p>
    <p>1、本次活动数字人民币红包为中国邮政储蓄银行数字人民币红包，可通过数字人民币APP-服务-红包查看红包详情。</p>
    <p>2、本次活动发放的数字人民币消费红包，可在数字人民币APP“服务-我的红包”中查看并领取，开通邮储数币钱包后可正常使用红包，仅支持在青岛地铁APP乘车使用，不能转给他人或兑回至本人银行账户。</p>
    <p>3、参与本次活动并成功领取邮储数币红包的客户，需先将邮储钱包升级至三类及以上（二类、一类）实名钱包。</p>
    <p>4、用户需登录青岛地铁APP，在“首页-我的-支付管理”中完成邮储银行数字人民币钱包签约绑定，并设置为默认支付方式。</p>
    <p>5、用户乘车时，使用青岛地铁APP乘车码扫码过闸，出站时自动完成扣款，优先使用数字人民币红包支付，请确保钱包余额充足，如数币红包余额不足，不足部分请进行数字人民币钱包充值后再进行乘车消费。</p>
    <p>6、若用户在使用期间发生注销钱包行为，活动发放的未使用数字人民币红包无论是否超过本次活动有效期，均自动返还至本次活动资金提供方。</p>
    <p>7、邮储银行数字人民币红包有效期：自领取之日起-2022年11月18日23:59:59。您还可通过数字人民币APP-服务-红包查看红包详情，活动结束时未使用的数字人民币红包余额将退回至资金提供方。</p>
    <p>8、如活动参与过程中有任何问题均可拨打青碳行APP客服热线0532-55772222进行咨询。客服服务时间：8:30-20:30。</p>
    <p>9、本次活动主办方：中国邮政储蓄银行股份有限公司青岛分行，7×24小时客服电话：95580。</p>
  `
}

export default {
  name: "RewardRulePage",
  components:{navBar},
  computed: {
    rule() {
      const prizeId = this.$route.query.prizeId;
      return rules[prizeId]
    },
    statusBarHeight() {
      return this.$store.state.user.statusBarHeight
    },
    type(){
      if(this.$route.query.type) return this.$route.query.type
      else return ''
    }
  },
  data(){
    return{
      fontColor: '#000',
      backUrl: blackBack
    }
  },
  methods:{
    goBack(){
      this.$router.go(-1)
    },
    watchScroll(scroll) {
      if (scroll <= 10) {
          this.fontColor = '#000'
          this.backUrl = blackBack
      } else {
          this.fontColor = '#fff'
          this.backUrl = whiteBack
      }
    }
  }
}
</script>

<style lang="scss">
@import "./components/function";
.nav-box {
    width: 100vw;
    padding: 0 pxvw(30);
    display: flex;
    align-items: center;
    justify-content: space-between;
    // color: #fff;
    font-size: pxvw(32);
    height: 10.333vw;
    .back {
        width: pxvw(34);
        height: pxvw(34);
    }
}
.rule-content {
    // height: 100vh;
    overflow: auto;
    padding: 0 px2rem(40);

    h3 {
        text-align: center;
        margin-top: px2rem(60);
    }

    p {
        margin-bottom: px2rem(20);
        font-size: 16px;
        letter-spacing: 1.5px;
        line-height: 1.5;
        text-align: justify;
        //word-break: break-all;
        display: flex;

        span {
            display: inline-block;
            flex-shrink: 0;
        }

        span[class="content"] {
            flex-shrink: 1;
        }
    }

    .list {
        .list-item {
            display: flex;
            justify-content: space-between;

            p {
                flex: 1;
                padding: 0 10px;
            }
        }
    }
}
</style>
